import { makeStyles } from '@material-ui/core';
import salsaLogo from '../../assets/salsa.png';

const useStyles = makeStyles({
  logo: {
    width: 170,
    height: 60,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      filter: 'drop-shadow(0 0 8px rgba(184, 32, 37, 0.4))',
    },
  },
  container: {
    marginLeft: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        src={salsaLogo}
        alt="Salsa Digital"
        className={classes.logo}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          if (target.parentElement) {
            target.parentElement.innerHTML = '<span style="color: #B82025; font-weight: 700; font-size: 20px;">SALSA</span>';
          }
        }}
      />
    </div>
  );
};

export default LogoFull;
